import { MEDIO_DE_PAGO } from "../../constants";
import {AyudaContainer ,AyudaTooltip  } from "./reportesComponents"
const getObservaciones = (row) => {
    if (row.observaciones && row.observaciones !== "") {
      return acortarString(row.observaciones,4);
    } else {
      return "Ninguna";
    }
  };
  function acortarString(texto, limite) {
    const palabras = texto.split(' ');
    const cantidadPalabras = palabras.length;
  
    if (cantidadPalabras <= limite) {
      return texto;
    } else {
      const palabrasAcortadas = palabras.slice(0, limite);
      const textoAcortado = palabrasAcortadas.join(' ');
      return textoAcortado + '...';
    }
  }
export const customStylesMovimientos = {
    rows: {
        style: {

        }
    },
    headCells: {
        style: {

            fontSize: '11px',
        },
    },
    cells: {
        style: {

            fontSize: '11px',
        },
    },
};

export const customStyles = {
    rows: {
        style: {
            minHeight: '20px', // override the row height
        }
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#debfb5',
            fontSize: '12px',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
            fontSize: '12px',
            allowOverflow: true,
        },
    },
};
export const columnasmovimientos = [
    {
        name: 'Codigo Producto',
        selector: row => { return (row.UserId + "." + row.codigoProducto) },

        wrap: true,
        sortable: true
    }
    , {
        name: 'Descripcion',
        selector: row => row.descripcion,
        wrap: true,
        sortable: true
    }, {
        name: 'Precio',
        selector: row => row.precio.toFixed(2),
        sortable: true
    }, {
        name: 'Operacion',
        selector: row => row.operacion,
        sortable: true
    }

];

export const columns = [
    {
        name: 'Fecha',
        selector: row => {
            const dt = new Date(row.fecha);
            return `${dt.getUTCDate()}/${dt.getUTCMonth() + 1}/${dt.getFullYear()}`;
        },
        sortable: true

    }, {
        name: "# Venta",
        selector: row => row.numero,
        wrap: true,
        sortable: true
    },
    {
        name: 'Cliente',
        selector: row => row.compradorId,
        wrap: true,
        sortable: true
    }, {
        name: 'Precio total',
        selector: row => `$${row.precioTotal.toFixed(2)}`,

        sortable: true
    },
    {
        name: 'Efectivo',
        selector: row =>`$${row.pagoEfectivo.toFixed(2)}`,

        sortable: true
    },
    {
        name: 'Cuenta Corriente',
        selector: row => `$${(row.pagoCredito).toFixed(2)}${row.saldoInsuficiente > 0 ? '!': ''}`,

        sortable: true
    },
    {
        name: 'Notas de credito',
        selector: row => {
            let simbol = '';
            if (row.notaCredito) simbol = '+ $';
            if (row.pagadoConNotaCredito) simbol = '- $'

            let finalString = simbol + (row.notaCredito || row.pagadoConNotaCredito || 0)

            return finalString;
        },

        sortable: true
    },

    {
        name: 'Otros',
        cell: (row) => {
            if (!row.otros || row.otros === 0) return '';
            let mp = "";
            if (row.medioDePago === MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TC || row.medioDePago === MEDIO_DE_PAGO.EFECTIVO_Y_TC || row.medioDePago === MEDIO_DE_PAGO.TC) {
                mp = 'T. Crédito: $';
            }
            if (row.medioDePago === MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TD || row.medioDePago === MEDIO_DE_PAGO.EFECTIVO_Y_TD || row.medioDePago === MEDIO_DE_PAGO.TD) {
                mp = "T. Débito: $";
            }
            if (row.medioDePago === MEDIO_DE_PAGO.CUENTA_CORRIENTE_Y_TRANSFERENCIA || row.medioDePago === MEDIO_DE_PAGO.EFECTIVO_Y_TRANSFERENCIA || row.medioDePago === MEDIO_DE_PAGO.TRANSFERENCIA) {
                mp = "Transferencia: $";
            }
            return `${mp}${row.otros.toFixed(2)}`;
        },
        sortable: true
    },    {
        name: 'Observaciones',
       
        cell: (row) => (
          <AyudaContainer>
            {getObservaciones(row)}
            <AyudaTooltip>{row.observaciones}</AyudaTooltip>
            </AyudaContainer>
        )

    }, {
        name: 'Origen de venta',
        selector: row => row.local,

        wrap: true,
        sortable: true
    }

];
export const opcionesdepagina = {
    rowsPerPageText: 'Filas por pagina',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Todo'
}
